'use client';

import React, { useEffect, useRef } from 'react';

const courses = [
  {
    emoji: '🎓',
    tag: 'Class 1–12',
    title: 'Academics',
    desc: 'Comprehensive coaching for Classes 1–12 across CBSE, ICSE, State and all major boards with strong concept-focused learning.',
    color: '#0C3E97',
    bg: 'bg-white',
    accent: '#0C3E97',
  },
  {
    emoji: '🛡️',
    tag: 'Military Schools',
    title: 'Sainik School',
    desc: 'Structured preparation for Sainik School entrance examinations with academic training, aptitude development and mock tests.',
    color: '#0C3E97',
    bg: 'bg-white',
    accent: '#0C3E97',
  },
  {
    emoji: '⭐',
    tag: 'Military Schools',
    title: 'RMS',
    desc: 'Focused coaching for Rashtriya Military School entrance exams with proven preparation strategies and practice programs.',
    color: '#0C3E97',
    bg: 'bg-white',
    accent: '#0C3E97',
  },
  {
    emoji: '📚',
    tag: 'Entrance Exam',
    title: 'Navodaya',
    desc: 'Comprehensive preparation for Jawahar Navodaya Vidyalaya entrance examinations with concept-based learning and test series.',
    color: '#0C3E97',
    bg: 'bg-white',
    accent: '#0C3E97',
  },
  {
    emoji: '🎯',
    tag: 'Class 11–12',
    title: 'PUC',
    desc: 'Science and Commerce PUC coaching designed to build strong academic performance and competitive exam readiness.',
    color: '#0C3E97',
    bg: 'bg-white',
    accent: '#F8B42D',
    
  },
  {
    emoji: '⚡',
    tag: 'Engineering Entrance',
    title: 'CET',
    desc: 'Result-oriented Karnataka CET preparation with concept mastery, intensive practice and regular performance analysis.',
    color: '#0C3E97',
    bg: 'bg-white',
    accent: '#0C3E97',
  },
  {
    emoji: '🩺',
    tag: 'Medical Entrance',
    title: 'NEET',
    desc: 'Comprehensive NEET coaching covering Physics, Chemistry and Biology with exam-focused preparation and mock testing.',
    color: '#0C3E97',
    bg: 'bg-white',
    accent: '#0C3E97',
  },
  {
    emoji: '🚀',
    tag: 'Engineering Entrance',
    title: 'JEE',
    desc: 'Advanced preparation for JEE Main and Advanced through deep concept building, problem solving and strategic mentoring.',
    color: '#0C3E97',
    bg: 'bg-white',
    accent: '#0C3E97',
  },
  {
    emoji: '💻',
    tag: 'Higher Education',
    title: 'B.E Subjects',
    desc: 'Expert guidance for engineering students across core subjects with practical understanding and exam preparation support.',
    color: '#0C3E97',
    bg: 'bg-white',
    accent: '#0C3E97',
  },
  {
    emoji: '🏆',
    tag: 'Government & Competitive',
    title: 'Competitive Exams',
    desc: 'Preparation for various competitive examinations with structured study plans, practice tests and expert mentoring.',
    color: '#0C3E97',
    bg: 'bg-white',
    accent: '#0C3E97',
  },
];

export default function CoursesSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);
  const cardsRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    let ctx: any;
    const init = async () => {
      const { gsap } = await import('gsap');
      const { ScrollTrigger } = await import('gsap/ScrollTrigger');
      gsap.registerPlugin(ScrollTrigger);

      ctx = gsap.context(() => {
        // Title
        if (titleRef.current) {
          gsap.fromTo(Array.from(titleRef.current.children),
            { opacity: 0, y: 35, filter: 'blur(8px)' },
            {
              opacity: 1, y: 0, filter: 'blur(0px)',
              duration: 0.9, stagger: 0.12, ease: 'power3.out',
              scrollTrigger: { trigger: titleRef.current, start: 'top 82%' },
            }
          );
        }

        // Staggered card entry
        cardsRef.current.forEach((card, i) => {
          if (!card) return;
          gsap.fromTo(card,
            { opacity: 0, y: 60, scale: 0.94 },
            {
              opacity: 1, y: 0, scale: 1,
              duration: 0.8, ease: 'power3.out',
              delay: (i % 3) * 0.1,
              scrollTrigger: { trigger: card, start: 'top 88%' },
            }
          );

          // Hover GSAP tilt
          const handleEnter = () => {
            gsap.to(card, { y: -8, scale: 1.02, duration: 0.3, ease: 'power2.out' });
          };
          const handleLeave = () => {
            gsap.to(card, { y: 0, scale: 1, duration: 0.4, ease: 'power2.out' });
          };
          card.addEventListener('mouseenter', handleEnter);
          card.addEventListener('mouseleave', handleLeave);
        });
      }, sectionRef);
    };

    init();
    return () => ctx?.revert();
  }, []);

  return (
    <section data-component-id="src/app/components/CoursesSection.tsx:155:4" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="155" data-component-end-line="258" data-component-file="CoursesSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22courses%22%2C%22className%22%3A%22py-24%20lg%3Apy-36%20bg-white%20overflow-hidden%22%7D" ref={sectionRef} id="courses" className="py-24 lg:py-36 bg-white overflow-hidden">
      <div data-component-id="src/app/components/CoursesSection.tsx:156:6" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="156" data-component-end-line="257" data-component-file="CoursesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%20lg%3Apx-12%22%7D" className="max-w-7xl mx-auto px-6 lg:px-12">

        {/* Title — left-aligned with right decorative element */}
        <div data-component-id="src/app/components/CoursesSection.tsx:159:8" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="159" data-component-end-line="180" data-component-file="CoursesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-12%20gap-8%20mb-16%20lg%3Amb-20%20items-end%22%7D" ref={titleRef} className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 lg:mb-20 items-end">
          <div data-component-id="src/app/components/CoursesSection.tsx:160:10" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="160" data-component-end-line="173" data-component-file="CoursesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-6%22%7D" className="lg:col-span-6">
            <span data-component-id="src/app/components/CoursesSection.tsx:161:12" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="161" data-component-end-line="163" data-component-file="CoursesSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22inline-block%20text-%5B10px%5D%20font-black%20uppercase%20tracking-%5B0.4em%5D%20text-%5B%230C3E97%5D%20mb-4%22%2C%22textContent%22%3A%22Our%20Courses%22%7D" className="inline-block text-[10px] font-black uppercase tracking-[0.4em] text-[#0C3E97] mb-4">
              Our Courses
            </span>
            <h2 data-component-id="src/app/components/CoursesSection.tsx:164:12" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="164" data-component-end-line="172" data-component-file="CoursesSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-3xl%20md%3Atext-4xl%20lg%3Atext-5xl%20font-black%20tracking-tight%20text-%5B%230F172A%5D%20leading-%5B1.1%5D%22%2C%22textContent%22%3A%22Every%20subject.%22%7D" className="text-3xl md:text-4xl lg:text-5xl font-black tracking-tight text-[#0F172A] leading-[1.1]">
              Every subject.{' '}
              <span data-component-id="src/app/components/CoursesSection.tsx:166:14" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="166" data-component-end-line="166" data-component-file="CoursesSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-%5B%230C3E97%5D%22%2C%22textContent%22%3A%22Every%20class.%22%7D" className="text-[#0C3E97]">Every class.</span>
              
              <span data-component-id="src/app/components/CoursesSection.tsx:168:14" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="168" data-component-end-line="171" data-component-file="CoursesSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22relative%22%2C%22textContent%22%3A%22Taught%20with%20clarity.%22%7D" className="relative">
                Taught with clarity.
                <span data-component-id="src/app/components/CoursesSection.tsx:170:16" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="170" data-component-end-line="170" data-component-file="CoursesSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20-bottom-1%20left-0%20w-full%20h-1%20bg-%5B%23F8B42D%5D%2F40%20rounded%22%7D" className="absolute -bottom-1 left-0 w-full h-1 bg-[#F8B42D]/40 rounded" />
              </span>
            </h2>
          </div>
          <div data-component-id="src/app/components/CoursesSection.tsx:174:10" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="174" data-component-end-line="179" data-component-file="CoursesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-4%20lg%3Acol-start-9%22%7D" className="lg:col-span-4 lg:col-start-9">
            <p data-component-id="src/app/components/CoursesSection.tsx:175:12" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="175" data-component-end-line="178" data-component-file="CoursesSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-base%20text-%5B%2364748B%5D%20leading-relaxed%22%2C%22textContent%22%3A%22From%20Class%201%20to%20competitive%20exams%20%E2%80%94%20we%20cover%20every%20stage%20of%20a%20student's%20academic%20journey%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20with%20the%20same%20commitment%20to%20concept%20clarity.%22%7D" className="text-base text-[#64748B] leading-relaxed">
              From Class 1 to competitive exams — we cover every stage of a student&apos;s academic journey
              with the same commitment to concept clarity.
            </p>
          </div>
        </div>

        {/* Asymmetric grid — varied sizes */}
        <div data-component-id="src/app/components/CoursesSection.tsx:183:8" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="183" data-component-end-line="243" data-component-file="CoursesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20lg%3Agrid-cols-3%20gap-5%22%7D" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {courses.map((course, i) => (
            <div data-component-id="src/app/components/CoursesSection.tsx:185:12" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="185" data-component-end-line="241" data-component-file="CoursesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              key={course.title}
              ref={(el) => { cardsRef.current[i] = el; }}
              className={`${course.bg} rounded-2xl p-8 border border-[#EAECEF] cursor-pointer relative overflow-hidden group transition-shadow duration-300 hover:shadow-[0_24px_60px_rgba(12,62,151,0.12)]`}
              style={{ opacity: 0 }}
            >
              {/* Gold accent line on hover */}
              <div data-component-id="src/app/components/CoursesSection.tsx:192:14" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="192" data-component-end-line="195" data-component-file="CoursesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20bottom-0%20left-0%20h-%5B3px%5D%20w-0%20group-hover%3Aw-full%20transition-all%20duration-500%20rounded-b-2xl%22%7D"
                className="absolute bottom-0 left-0 h-[3px] w-0 group-hover:w-full transition-all duration-500 rounded-b-2xl"
                style={{ background: `linear-gradient(to right, ${course.accent}, ${course.accent}60)` }}
              />

              <div data-component-id="src/app/components/CoursesSection.tsx:197:14" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="197" data-component-end-line="207" data-component-file="CoursesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20justify-between%20mb-6%22%7D" className="flex items-start justify-between mb-6">
                <div data-component-id="src/app/components/CoursesSection.tsx:198:16" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="198" data-component-end-line="198" data-component-file="CoursesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-3xl%22%7D" className="text-3xl">{course.emoji}</div>
                <span data-component-id="src/app/components/CoursesSection.tsx:199:16" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="199" data-component-end-line="206" data-component-file="CoursesSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                  className={`text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-full ${
                    course.dark
                      ? 'bg-white/15 text-white' :'bg-[#0C3E97]/8 text-[#0C3E97]'
                  }`}
                >
                  {course.tag}
                </span>
              </div>

              <h3 data-component-id="src/app/components/CoursesSection.tsx:209:14" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="209" data-component-end-line="215" data-component-file="CoursesSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%7D"
                className={`text-xl font-black mb-3 leading-snug ${
                  course.dark ? 'text-white' : 'text-[#0F172A]'
                }`}
              >
                {course.title}
              </h3>
              <p data-component-id="src/app/components/CoursesSection.tsx:216:14" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="216" data-component-end-line="222" data-component-file="CoursesSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%7D"
                className={`text-sm leading-relaxed ${
                  course.dark ? 'text-white/70' : 'text-[#64748B]'
                }`}
              >
                {course.desc}
              </p>

              {/*<div className="mt-6 flex items-center gap-2">
                <span
                  className={`text-xs font-black uppercase tracking-widest ${
                    course.dark ? 'text-[#F8B42D]' : 'text-[#0C3E97]'
                  }`}
                >
                  Learn More
                </span>
                <svg
                  className={`w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1.5 ${
                    course.dark ? 'text-[#F8B42D]' : 'text-[#0C3E97]'
                  }`}
                  fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </div> */}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div data-component-id="src/app/components/CoursesSection.tsx:246:8" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="246" data-component-end-line="256" data-component-file="CoursesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-12%20text-center%22%7D" className="mt-12 text-center">
          <a data-component-id="src/app/components/CoursesSection.tsx:247:10" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="247" data-component-end-line="255" data-component-file="CoursesSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%23location%22%2C%22className%22%3A%22group%20inline-flex%20items-center%20gap-2.5%20bg-%5B%23F8B42D%5D%20text-%5B%230F172A%5D%20font-black%20text-sm%20uppercase%20tracking-widest%20rounded-full%20px-8%20py-4%20hover%3Ascale-%5B1.04%5D%20hover%3Ashadow-%5B0_8px_32px_rgba(248%2C180%2C45%2C0.4)%5D%20transition-all%20duration-300%22%2C%22textContent%22%3A%22Book%20a%20Free%20Demo%20Class%22%7D"
            href="#location"
            className="group inline-flex items-center gap-2.5 bg-[#F8B42D] text-[#0F172A] font-black text-sm uppercase tracking-widest rounded-full px-8 py-4 hover:scale-[1.04] hover:shadow-[0_8px_32px_rgba(248,180,45,0.4)] transition-all duration-300"
          >
            Book a Free Demo Class
            <svg data-component-id="src/app/components/CoursesSection.tsx:252:12" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="252" data-component-end-line="254" data-component-file="CoursesSection.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-4%20h-4%20transition-transform%20duration-300%20group-hover%3Atranslate-x-1%22%7D" className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path data-component-id="src/app/components/CoursesSection.tsx:253:14" data-component-path="src/app/components/CoursesSection.tsx" data-component-line="253" data-component-end-line="253" data-component-file="CoursesSection.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}